export default __webpack_public_path__ + "static/windows-9d2b73dc85df299afa924f0c7ac073b7.png";